import { AnimatePresence, motion } from "framer-motion";
import { usePush } from "../hooks/usePush";
import { easeOut } from "../motion";

export function PushToggle() {
  const { enabled, permission, subscribed, enable, disable } = usePush();
  if (!enabled) return null;
  const on = subscribed && permission === "granted";
  const busy = enable.isPending || disable.isPending;
  const label = busy ? "\u2026" : on ? "On" : "Off";
  return (
    <div className="push-toggle">
      <div className="push-toggle-text">
        <strong>Push digest</strong>
      </div>
      <motion.button
        type="button"
        className={`btn ${on ? "btn-primary" : "btn-secondary"}`}
        disabled={busy}
        onClick={() => (on ? disable.mutate() : enable.mutate())}
        style={{ minHeight: 36, padding: "0 var(--space-3)" }}
        whileTap={{ scale: 0.95 }}
      >
        <AnimatePresence mode="wait" initial={false}>
          <motion.span
            key={label}
            style={{ display: "inline-block" }}
            initial={{ opacity: 0, y: -6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 6 }}
            transition={{ duration: 0.18, ease: easeOut }}
          >
            {label}
          </motion.span>
        </AnimatePresence>
      </motion.button>
    </div>
  );
}